import HomePage from "../../components/HomePage";
function HomePagePage() {
  return (
    <div>
      <HomePage />
    </div>
  );
}

export default HomePagePage;
